import { useXcoreUtils } from "@robe/client/xcore-ui";
import { Content, RelationValue } from "@robe/core";
import { Box, Flex, Typography } from "@xcorejs/ui";
import { Dispatch, Fragment } from "react";
import { ProductOverviewPage } from "xcore/types";
import { ProductDropdownContentLink, TagStyle, TextStyle } from ".";

type RightSectionProps = {
  otherTypes: Content[];
  gridSection1: RelationValue<ProductOverviewPage>;
  gridSection2: RelationValue<ProductOverviewPage>;
  setOpen: Dispatch<boolean>;
  newIconText: string;
};

const RightSection = ({ otherTypes, gridSection1, gridSection2, setOpen, newIconText }: RightSectionProps) => {
  const { stringify, localize } = useXcoreUtils();

  const gridSection1Items = localize(gridSection1.values?.itemsRelation);
  const gridSection2Items = localize(gridSection2.values?.itemsRelation);

  return (
    <Box padding="40px 10px 40px 30px">
      {otherTypes.map((type) => (
        <ProductDropdownContentLink key={type.id} display="block" content={type} setOpen={setOpen}>
          <Typography {...Heading} {...TextStyle} textTransform="uppercase">
            {stringify(type.title)}
          </Typography>
        </ProductDropdownContentLink>
      ))}

      {gridSection1?.type && gridSection1?.slug && localize(gridSection1.slug) && (
        <Box>
          <ProductDropdownContentLink
            marginTop="20px"
            setOpen={setOpen}
            content={{ id: gridSection1.id, type: gridSection1.type, slug: gridSection1.slug }}
          >
            <Typography {...Heading} {...TextStyle} textTransform="uppercase">
              {stringify(gridSection1.title)}
            </Typography>
          </ProductDropdownContentLink>
          <Box>
            {gridSection1Items?.map((v, i) => {
              const type = v.type;

              if (!v?.slug || !v.values || !type) {
                return <Fragment key={i} />;
              }

              return (
                <ProductDropdownContentLink display="block" key={i} content={{ slug: v.slug, type, id: v.id }} setOpen={setOpen}>
                  <Flex>
                    <Typography py="0.25rem" fontWeight={600} color="darkGray" _hover={{ color: "black" }} {...TextStyle}>
                      {stringify(v.title)}
                    </Typography>
                    {v.values?.textTag && (
                      <Typography pl="0.5rem" fontSize="1rem">
                        {stringify(v.values.textTag)}
                      </Typography>
                    )}
                    {v.values && "newIcon" in v.values && v.values.newIcon && (
                      <Box mt="0.25rem" padding="0 0.5rem" {...TagStyle}>
                        {stringify(newIconText)}
                      </Box>
                    )}
                  </Flex>
                </ProductDropdownContentLink>
              );
            })}
          </Box>
        </Box>
      )}

      {gridSection2?.type && gridSection2?.slug && localize(gridSection2.slug) && (
        <Box>
          <ProductDropdownContentLink
            marginTop="20px"
            setOpen={setOpen}
            content={{ id: gridSection2.id, type: gridSection2.type, slug: gridSection2.slug }}
          >
            <Typography {...Heading} {...TextStyle} textTransform="uppercase">
              {stringify(gridSection2.title)}
            </Typography>
          </ProductDropdownContentLink>
          <Box>
            {gridSection2Items?.map((v, i) => {
              const type = v.type;

              if (!v?.slug || !v.values || !type) {
                return <Fragment key={i} />;
              }

              return (
                <ProductDropdownContentLink
                  position="relative"
                  width="fit-content"
                  display="block"
                  key={i}
                  content={{ id: v.id, type, slug: v.slug }}
                  setOpen={setOpen}
                >
                  <Flex>
                    <Typography py="0.25rem" fontWeight={600} color="darkGray" _hover={{ color: "black" }} {...TextStyle}>
                      {stringify(v.title)}
                    </Typography>
                    {v.values?.textTag && (
                      <Typography pl="0.5rem" fontSize="1rem">
                        {stringify(v.values.textTag)}
                      </Typography>
                    )}
                    {v.values && "newIcon" in v.values && v.values.newIcon && (
                      <Box mt="0.25rem" padding="0 0.5rem" {...TagStyle}>
                        {stringify(newIconText)}
                      </Box>
                    )}
                  </Flex>
                </ProductDropdownContentLink>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default RightSection;

const Heading = {
  fontWeight: 700,
  color: "black",
  padding: "3px 0",
};
